import { SvrConn } from "../utils/axios/index";
/**
 * metodo para traer las areas
 */
export const getAreas = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/area/getArea");
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 *
 */
export const getAreasAll = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/area/getareasall");
  } catch (Error) {
    res = Error;
  }
  return res;
};

/**
 *  Metodo para Traer un area especifica
 */
export const getAreaInt = async (AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/area/getAreaInt", { AreaId });
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 *
 */
export const setBloqueaArea = async (AreaId, TagId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/area/setBloqueaArea", { AreaId, TagId });
  } catch (Error) {
    res = Error;
  }
  return res;
};

/**
 *  Metodo para Traer los mensajes de un area
 */
export const getMensajexArea = async (AreaId) => {
  let res = {};
  try {
    res = await SvrConn.get("/api/area/getMensajesArea", {
      AreaId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

/**
 * metodo para traer las areas
 */
export const ActualizaArea = async (data) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/area/setActualizaArea", data);
  } catch (Error) {
    res = Error;
  }
  return res;
};
